// 地图元素  main_type  0- 路径 1-虚拟墙，2-去噪点区域，3-工作站, 4-定位点，5-功能区
import MapElement2 from "@/model/MapElement2";

const main_type_line_0 = 0;
const main_type_virtualWall_1 = 1;
const main_type_noisyPoint_2 = 2;
const main_type_functionPoint_3 = 3;
const main_type_anchorPoint_4 = 4;
const main_type_zone_5 = 5;

const sub_type_0 = 0; //全部
const sub_type_1 = 1; // 加水点
const sub_type_2 = 2; // 排水点
const sub_type_3 = 3; // 充电点
const sub_type_4 = 4; // 导航点
const sub_type_5 = 5; // 停靠点
const sub_type_6 = 6; // 补给站

const mapElementsUtil = (
  el: Array<MapElement2>,
  main_type: number
): MapElement2[] => {
  const res = el?.filter((e) => {
    return e.main_type == main_type;
  });
  return res;
};

export {
  mapElementsUtil,
  main_type_line_0,
  main_type_virtualWall_1,
  main_type_noisyPoint_2,
  main_type_functionPoint_3,
  main_type_anchorPoint_4,
  main_type_zone_5,
  sub_type_0,
  sub_type_1,
  sub_type_2,
  sub_type_3,
  sub_type_4,
  sub_type_5,
  sub_type_6,
};
